import React, { useState, useEffect } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 10);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${
            isScrolled
                ? 'bg-dark/90 backdrop-blur-xl border-b border-white/5 shadow-lg shadow-black/20'
                : 'bg-dark/70 backdrop-blur-lg border-b border-white/5'
        }`} id="navbar">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">

                    {/* Logo */}
                    <div className="flex-shrink-0 flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
                        <img src="/logo_rd.png" alt="Next Pro 360" className="w-10 h-10 rounded-xl object-contain" />
                        <span className="font-black text-xl tracking-tight text-white">Next <span className="text-brand-400">Pro 360</span></span>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        <a href="#inicio"    className="text-white/60 hover:text-white font-medium transition-colors text-sm">Inicio</a>
                        <a href="#servicios" className="text-white/60 hover:text-white font-medium transition-colors text-sm">Funciones</a>
                        <a href="#nosotros"  className="text-white/60 hover:text-white font-medium transition-colors text-sm">Beneficios</a>
                        <a href="#precios"   className="text-white/60 hover:text-white font-medium transition-colors text-sm">Precio</a>
                        <a href="#contacto"  className="text-white/60 hover:text-white font-medium transition-colors text-sm">Contacto</a>
                        <a href="#contacto"
                            className="bg-gradient-to-r from-brand-600 to-brand-500 text-white px-6 py-2.5 rounded-full font-bold text-sm hover:opacity-90 transition-all shadow-lg shadow-brand-600/30 hover:scale-105 hover:shadow-brand-500/40">
                            Registrar mi Negocio
                        </a>
                    </div>

                    {/* Mobile button */}
                    <div className="md:hidden flex items-center">
                        <button className="text-white/60 hover:text-white focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                            {isMenuOpen ? (
                                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            ) : (
                                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden bg-dark/95 backdrop-blur-xl border-t border-white/5 absolute w-full shadow-xl`}>
                <div className="px-4 pt-2 pb-6 space-y-1">
                    <a href="#inicio"    onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-lg text-sm font-medium text-white/60 hover:text-white hover:bg-white/5">Inicio</a>
                    <a href="#servicios" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-lg text-sm font-medium text-white/60 hover:text-white hover:bg-white/5">Funciones</a>
                    <a href="#nosotros"  onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-lg text-sm font-medium text-white/60 hover:text-white hover:bg-white/5">Beneficios</a>
                    <a href="#precios"   onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-lg text-sm font-medium text-white/60 hover:text-white hover:bg-white/5">Precio</a>
                    <a href="#contacto"  onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-lg text-sm font-medium text-white/60 hover:text-white hover:bg-white/5">Contacto</a>
                    <div className="pt-3 px-3">
                        <a href="#contacto" onClick={() => setIsMenuOpen(false)}
                            className="w-full flex justify-center bg-gradient-to-r from-brand-600 to-brand-500 text-white px-6 py-3 rounded-xl font-bold text-sm hover:opacity-90 transition-all">
                            Registrar mi Negocio
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header;
